// @flow

import styled, { css } from 'styled-components';
import type { Theme } from '../../../types';
import check from '../check.svg';
import { svgEncode } from '../../../helpers';

type Props = {
  error: boolean,
  valid: boolean,
};

const Input = styled<any, Theme, Props>('input')`
  height: 2.5em;
  border-radius: 4px;
  border: 1px solid ${props => props.theme.form.input.borderColor};
  box-sizing: border-box;
  width: 100%;
  font-size: 1rem;
  padding: 0 0.75em;
  ${props => props.error && css`
    border-color: ${props.theme.form.input.borderColorError};
    border-radius: 4px 4px 0 0;
  `};
  ${props => props.valid && !props.error && css`
    background: url('data:image/svg+xml;utf8,${svgEncode(check)}') right 1em center no-repeat white;
    background-size: 1em auto;
  `};

  &::placeholder {
    color: ${props => props.theme.form.placeholderColor};
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 8px 0 ${props => props.theme.form.focusColor};
  }
`;

export default Input;
